import { Box, Tab, Tabs } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

const getTabStyle = (selected: boolean) => ({
  borderBottom: selected ? "5px solid var(--primary-mint-500)" : "none",
  fontSize: "16px",
  fontWeight: "800",
  textTransform: "none",
});

type NotificationsTabsProps = {
  selectedTab: string;
  setSelectedTab: (arg0: string) => void;
};

export const NotificationsTabs: React.FC<NotificationsTabsProps> = ({ selectedTab, setSelectedTab }) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ borderBottom: "1px solid var(--grey-color-300)" }}>
      <Tabs value={value} onChange={handleChange}>
        <Tab
          value="1"
          label={t("notifications.Direct")}
          sx={{
            ...getTabStyle(selectedTab === "Application"),
          }}
          onClick={() => setSelectedTab("Application")}
        />
        <Tab
          value="2"
          label={t("notifications.Product")}
          sx={{
            ...getTabStyle(selectedTab === "Product"),
          }}
          onClick={() => setSelectedTab("Product")}
        />
      </Tabs>
    </Box>
  );
};
